<template>
    <v-container fill-height>
        <v-row justify="center">
            <v-col xs="10" sm="6" md="3">
                <div  class="pa-4 grey lighten-4 elevation-6">
                    <div class="d-flex justify-center "><img src="../assets/abalogo.png" class="pb-5"></div>
                    <v-text-field color="black" prepend-inner-icon="mdi-account " v-model="usuario" :rules="[rules.required]" dense outlined label="Usuario" autofocus></v-text-field>
                    <br>
                    <v-text-field color="black" prepend-inner-icon="mdi-key" v-model="contraseña" @keypress.enter="autenticar" :rules="[rules.required]" dense outlined label="Contraseña" type ='password'></v-text-field>
                    <br>
                    <v-btn @click="autenticar" class="secondary text--primary" width="100%" :loading="validando" >Entrar</v-btn>      
                </div>
            </v-col>
        </v-row>        
        <v-snackbar v-model="snackbar" :timeout="snackbar_timeout">{{snackbar_msj}}</v-snackbar>

    </v-container>
</template>

<script>
import axios from 'axios';
import cookie from 'vue-cookie';
export default {
    data() {
        return {
            validando: false,
            usuario: '',
            contraseña: '',
            snackbar: false,
            snackbar_timeout: 3000,
            snackbar_msj: "",
            rules:{
                required: value => !!value || 'Requerido'
            }
        }
    },
    methods: {
        autenticar: function(){

           this.validando = true            
           axios.post(this.$url+'/acceso/validacion', {usuario: this.usuario, password: this.contraseña})
                .then((response)=>{
                    if(response.data.acceso){
                        cookie.set('token', response.data.token, 1)


                        this.$store.commit('setMenu',response.data.menu)
                        
                        this.$router.push({name: 'MenuPrincipal'})
                    }
                    else{
                        this.snackbar_msj = response.data.mensaje;
                        this.limpiar_campos(),
                        this.snackbar = true;                        
                    }
                })
                .catch((error)=>{
                    this.snackbar_msj = 'Error en la conexión.'
                })
                .finally(()=>{
                    this.validando = false
                })
                 
        },
        
        limpiar_campos: function(){
            // this.usuario = "";
            this.contraseña = "";
        } 
    
    },
}
</script>

<style lang="">

</style>